<div class="card mb-0 text-dark">
  <div class="card-header">
    <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
      @if (expanded) {
        <span class="dripicons-chevron-up"></span>
      }
      @if (!expanded) {
        <span class="dripicons-chevron-down"></span>
      }
    </button>
    Commission Setup
    <button class="btn btn-sm btn-primary float-right" [disabled]="commissionForm.invalid" (click)="saveCommission()">
      Save
    </button>
  </div>
  @if (expanded) {
    <div id="commission-content-collapse">
      <div class="card-body">
        @if (commissionForm.valid) {
          <form [formGroup]="commissionForm" class="m-0">
            <div class="row">
              <div class="col-md-6">
                <h5 class="justify-content-between d-flex">
                  Sales
                  <span><input type="checkbox" formControlName="frontEnd"></span>
                </h5>
                <ul>
                  <li class="d-flex align-items-center justify-content-between">
                    <div class="col-9">RATE on profit applied to Cash and Outside Finance deals
                      <span>(overrides FLAT Amount per deal commission)</span>
                    </div>
                    <percent-input [control]="commissionForm.get('salesRateOnProfitCashOutside')" (change)="switchFlatOrRate('salesRateOnProfitCashOutside')"></percent-input>
                  </li>
                  <li class="d-flex align-items-center justify-content-between">
                    <div class="col-9">FLAT Amount per deal
                      <span>(overrides RATE on profit applied to Cash and Outside Finance deals commission)</span></div>
                      <currency-input [control]="commissionForm.get('salesFlatPerDeal')" (change)="switchFlatOrRate('salesFlatPerDeal')"></currency-input>
                    </li>
                    <li class="d-flex align-items-center justify-content-between">
                      <div class="col-9">RATE on DOWN PAYMENT applied to BHPH deals</div>
                      <currency-input [control]="commissionForm.get('salesRateDownPaymentBHPH')"></currency-input>
                    </li>
                    <li class="d-flex align-items-center justify-content-between">
                      <div class="col-9">RATE on DEFERRED PAYMENTS applied to BHPH deals</div>
                      <currency-input [control]="commissionForm.get('salesRateDeferredPaymentBHPH')"></currency-input>
                    </li>
                    <li class="d-flex align-items-center justify-content-between">
                      <div class="col-9">RATE on PAYMENTS applied to BHPH deals</div>
                      <currency-input [control]="commissionForm.get('salesRatePaymentBHPH')"></currency-input>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <h5 class="justify-content-between d-flex">
                    F &amp; I
                    <span><input type="checkbox" formControlName="backEnd"></span>
                  </h5>
                  <ul>
                    <li class="d-flex align-items-center justify-content-between">
                      <div class="col-9">RATE on Back-End profits</div>
                      <percent-input [control]="commissionForm.get('fiRateOnBEProfit')"(change)="switchFlatOrRate('fiRateOnBEProfit')"></percent-input>
                    </li>
                    <li class="d-flex align-items-center justify-content-between">
                      <div class="col-9">FLAT Amount per deal</div>
                      <currency-input [control]="commissionForm.get('fiFlatPerDeal')"(change)="switchFlatOrRate('fiFlatPerDeal')"></currency-input>
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    }
  </div>